import type { GasSettingsVariant } from '../../atoms/transfer-fee-reatom'
import type { TransKey } from '@root/shared/localization'

export const GAS_VARIANT_LABEL_MAP: Record<GasSettingsVariant, TransKey> = {
  high: 'gas-settings.option.high',
  market: 'gas-settings.option.market',
  low: 'gas-settings.option.low',
  advanced: 'gas-settings.option.advanced',
}

export type AvgTimeRating = 'fast' | 'medium' | 'slow'
